import React, { ReactNode, SetStateAction, useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import Slider from 'component/Layout/Slider';

import classNames from 'classnames';
import { Pagination } from 'swiper/modules';

import LazyImage from 'utility/Bind/Lazy/lazyImage';
import { isTablet } from 'utility/Check/Device';

import { Image } from 'proto/Media/Image';

import {
    forceLazyLoad,
    getThumbnailList,
} from '../../__helper/getThumbnailList';

import styles from './Thumbnail.module.scss';

export interface ThumbnailProps {
    media: string | Image[];
    altText?: string;
    customClass?: {
        SingleImageWrapper?: string;
        SingleImage?: string;
        Thumbnail?: string;
    };
    hotelId: number;
    clickHandler?: () => void;
    setCurrentIndex?: React.Dispatch<SetStateAction<number>>;
}

const hideNavigation = isTablet();
const Thumbnail = ({
    media,
    altText = '',
    customClass,
    clickHandler,
    hotelId,
    setCurrentIndex,
}: ThumbnailProps) => {
    const { t } = useTranslation();
    const handleDragStart = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
    };
    const hasSwipedRef = useRef(false);
    let sliderSettings = {
        navigation: true,
        watchSlidesProgress: true,
    };

    if (hideNavigation) {
        sliderSettings = { ...sliderSettings, navigation: false };
    }

    const onSliderMove = useCallback(() => {
        forceLazyLoad();
    }, []);
    const onAfterInit = useCallback(() => {
        hasSwipedRef.current = false;
        forceLazyLoad();
    }, []);

    return (
        <div
            className={classNames(styles.Thumbnail, customClass?.Thumbnail)}
            data-hotelid={hotelId}
        >
            {typeof media === 'string' || media.length === 1 ? (
                <div className={customClass?.SingleImageWrapper}>
                    <LazyImage
                        className={customClass?.SingleImage}
                        src={typeof media === 'string' ? media : media[0].url}
                        alt={altText}
                        onDragStart={handleDragStart}
                    />
                </div>
            ) : (
                <Slider
                    clickHandler={clickHandler}
                    onSlideChangeCallback={onSliderMove}
                    onAfterInitCallback={onAfterInit}
                    navigationOnSlider={true}
                    settings={sliderSettings}
                    setCurrentIndex={setCurrentIndex}
                    classListObject={{
                        SliderWrapper: styles.Wrapper,
                        Slider: styles.Slider,
                        Slide: styles.Slide,
                        PrevButton: styles.PrevButton,
                        NextButton: styles.NextButton,
                        Pagination: styles.Pagination,
                    }}
                    moduleList={[Pagination]}
                >
                    {
                        getThumbnailList(
                            media,
                            t('TRANS-click-for-more-images'),
                            altText,
                            handleDragStart
                        ) as ReactNode[]
                    }
                </Slider>
            )}
        </div>
    );
};
export default Thumbnail;
